module.exports = __webpack_public_path__ + "img/m-logo.8d9b2f68.jpg";